'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/~/promise/index.js
// module id = 114
// module chunks = 10 11 12 13 14